<template>
	<v-dialog v-model="dialog" width="700">
		<v-card>
			<v-btn
				class="dialog__close"
				icon
				x-small
				@click.native="dialog = false"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>

			<v-card-title>
				<v-tabs
					v-model="cookieTab"
					:grow="!verticalTab"
					:vertical="verticalTab"
					:class="verticalTab ? 'tab-header' : ''"
				>
					<v-tab href="#cookieAcceptance">
						{{ $t("cookie-banner.general-tab-title") }}
					</v-tab>
					<v-tab href="#cookiePolicy">
						{{ $t("cookie-banner.policy-tab-title") }}
					</v-tab>
				</v-tabs>
			</v-card-title>

			<v-card-text class="text-left">
				<v-tabs-items v-model="cookieTab">
					<v-tab-item value="cookieAcceptance">
						<i18n path="cookie-banner.general-information">
							<template v-slot:policy>
								<b
									class="policy-ref"
									@click="switchTab('cookiePolicy')"
								>
									{{ $t("cookie-banner.policy") }}
								</b>
							</template>
						</i18n>
					</v-tab-item>
					<v-tab-item value="cookiePolicy">
						<h3 class="text-center">
							{{ $t("cookie-banner.policy-title") }}
						</h3>
						<br />
						<br />
						<b>{{ $t("cookie-banner.cookie-title") }}</b>
						<br />
						{{ $t("cookie-banner.cookie-explanation") }}
						<br />
						<br />
						<b>
							{{ $t("cookie-banner.responsible-title") }}
						</b>
						<br />
						{{ $t("cookie-banner.responsible-explanation1") }}
						<br />
						{{ $t("cookie-banner.responsible-explanation2") }}
						<br />
						<br />
						<b>
							{{ $t("cookie-banner.types-title") }}
						</b>
						<br />
						{{ $t("cookie-banner.types-used1") }}
						{{ $t("cookie-banner.types-used2") }}
						<br />
						<br />
						<b>
							{{ $t("cookie-banner.technical-title") }}
						</b>
						<br />
						{{ $t("cookie-banner.technical-explanation") }}
						<br />
						<br />
						{{ $t("cookie-banner.technical-list-title") }}
						<br />
						{{ $t("cookie-banner.technical-domain") }}
						<v-container class="grid pa-0">
							<v-row no-gutters>
								<v-col cols="2" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-list-category"
										)
									}}
								</v-col>
								<v-col cols="2" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-list-cookie"
										)
									}}
								</v-col>
								<v-col cols="2" class="pa-1">
									{{
										$t("cookie-banner.technical-list-owner")
									}}
								</v-col>
								<v-col cols="2" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-list-duration"
										)
									}}
								</v-col>
								<v-col cols="4" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-list-description"
										)
									}}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="2" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-category-type1"
										)
									}}</v-col
								>
								<v-col cols="2" class="pa-1">
									current-category
								</v-col>
								<v-col cols="2" class="pa-1">
									{{ $t("cookie-banner.coupontools") }}
								</v-col>
								<v-col cols="2" class="pa-1">
									{{ $t("cookie-banner.technical-duration") }}
								</v-col>
								<v-col cols="4" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-description1"
										)
									}}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="2" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-category-type1"
										)
									}}
								</v-col>
								<v-col cols="2" class="pa-1">
									accessToken
								</v-col>
								<v-col cols="2" class="pa-1">
									{{ $t("cookie-banner.coupontools") }}
								</v-col>
								<v-col cols="2" class="pa-1">
									{{ $t("cookie-banner.technical-duration") }}
								</v-col>
								<v-col cols="4" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-description2"
										)
									}}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="2" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-category-type2"
										)
									}}
								</v-col>
								<v-col cols="2" class="pa-1">
									deviceUuid
								</v-col>
								<v-col cols="2" class="pa-1">
									{{ $t("cookie-banner.coupontools") }}
								</v-col>
								<v-col cols="2" class="pa-1">
									{{ $t("cookie-banner.technical-duration") }}
								</v-col>
								<v-col cols="4" class="pa-1">
									{{
										$t(
											"cookie-banner.technical-description3"
										)
									}}
								</v-col>
							</v-row>
						</v-container>
						<br />
						<b>{{ $t("cookie-banner.choice-title") }}</b>
						<br />
						{{ $t("cookie-banner.choice-intro") }}
						<ul>
							<li>
								{{ $t("cookie-banner.choice1") }}
							</li>
							<li>
								{{ $t("cookie-banner.choice2") }}
							</li>
						</ul>
						{{ $t("cookie-banner.choice-information") }}
						<br />
						<br />
						<b>{{ $t("cookie-banner.contact-title") }}</b>
						<br />
						{{ $t("cookie-banner.contact-information") }}
						<a href="mailto:info@coupontools.com">
							info@coupontools.com
						</a>
					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
			<v-card-actions>
				<v-btn depressed outlined @click="setCookie(false)">
					{{ $t("cookie-banner.reject-button") }}
				</v-btn>

				<v-btn depressed color="success" @click="setCookie(true)">
					{{ $t("cookie-banner.accept-button") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Cookies from "js-cookie";

export default {
	name: "cookeBanner",
	data() {
		return {
			dialog: false,
			cookieTab: "cookieAcceptance",
			verticalTab: false,
		};
	},
	methods: {
		setCookie(allow) {
			// let exdate = new Date();
			// exdate.setDate(exdate.getDate() + this.expires);

			Cookies.set("allowAnalyticsCookie", allow);
			if (allow) this.acceptCookies();
			this.dialog = false;
		},
		close() {
			this.setCookie(false);
			this.dialog = false;
		},
		loadFacebookPixel() {
			this.$emit("loadFacebookPixel");
		},
		loadGoogleAnalytics() {
			this.$emit("loadGoogleAnalytics");
		},
		addDeviceUUID() {
			this.$emit("addDeviceUUID");
		},
		acceptCookies() {
			if (this.directory.googleAnalytics) {
				this.loadGoogleAnalytics();
			}
			if (this.directory.facebookPixel) {
				this.loadFacebookPixel();
			}
			if (this.directory.customerId === "25065") {
				this.addDeviceUUID();
			}
		},
		switchTab(target) {
			this.cookieTab = target;
		},
	},
	created() {
		const getAllowAnalyticsCookie = Cookies.get("allowAnalyticsCookie");
		if (getAllowAnalyticsCookie === undefined) {
			setTimeout(() => {
				this.dialog = true;
			}, 1);
		} else if (getAllowAnalyticsCookie) {
			this.acceptCookies();
		}
	},
	mounted() {
		if (window.outerWidth <= 600) this.verticalTab = true;
	},
	computed: {
		directory() {
			return this.$store.getters["directory/getDirectory"];
		},
	},
};
</script>

<style scoped>
.policy-ref {
	cursor: pointer;
	text-decoration: underline;
}
.grid {
	font-size: 12px;
	border: 1px solid black;
}
.grid .col {
	border: 1px solid black;
}
.tab-header .v-tab {
	font-size: small;
	flex-direction: column;
	width: 100%;
	text-wrap: wrap;
}
</style>